import type { Theme } from "@mui/material"

export const FILTER_FIELD_HEIGHT = 40

/** Border color at rest */
export const filterFieldBorderColor = (palette: Theme["palette"]) => palette.divider

/** Border color on hover & focus */
export const filterFieldActiveBorderColor = (palette: Theme["palette"]) =>
  palette.common.darkBlue
